import React, { useEffect, useState } from 'react'
import SearchShow from '../search/SearchShow'
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore'
import { db } from '../../firebaseConfig/firebase'
import ProductsShow from '../products/ProductsShow'
import ProductModal from '../products/ProductModal'

const MainShow = () => {

  const parametersCollection = collection(db, "parameters")

  const [product, setProduct] = useState(null)
  const [products, setProducts] = useState([])

  const [whatsAppPhoneNumber, setWhatsAppPhoneNumber] = useState("")
  const [whatsAppDefaultText, setWhatsAppDefaultText] = useState("")
  const [shippingPrice, setShippingPrice] = useState(0)

  const getGeneralParameters = async () => {
    if (whatsAppPhoneNumber === "") {
      const parametersQuery = query(parametersCollection, where("code", "in", ['whatsAppPhoneNumber', 'whatsAppDefaultText', 'ShippingPrice']));
      const parametersDocs = await getDocs(parametersQuery)
      parametersDocs.forEach(parameter => {
        switch (parameter.data().code) {
          case 'whatsAppPhoneNumber':
            setWhatsAppPhoneNumber(parameter.data().value)
            break
          case 'whatsAppDefaultText':
            setWhatsAppDefaultText(parameter.data().value)
            break
          case 'ShippingPrice':
            setShippingPrice(parameter.data().value)
            break
          default:
            break
        }
      });
    }
  }

  const SelectProduct = async function (productId) {
    const ref = await doc(db, 'products', productId)
    const productDoc = await getDoc(ref)
    if (productDoc.exists) {
      setProduct({id: productDoc.id, ...productDoc.data()});
    } else {
      console.log("Producto no encontrado");
    }
  }

  const SelectProducts = async function (e) {
    setProducts(e)
  }

  useEffect(() => {
    getGeneralParameters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='container'>
      <div className='row mt-3'>

        <SearchShow
          SelectProductFunction={(e) => SelectProduct(e)}
          SelectProductsFunction={(e) => SelectProducts(e)}
        />


      </div>
      <div className='row'>

        <ProductsShow
          pWhatsAppPhoneNumber={whatsAppPhoneNumber}
          pWhatsAppDefaultText={whatsAppDefaultText}
          products={products}
        />

        <ProductModal
          pProduct={product}
          pWhatsAppDefaultText={whatsAppDefaultText}
          pWhatsAppPhoneNumber={whatsAppPhoneNumber}
          pShippingPrice={shippingPrice}
        />

      </div>
      <div className='row'>
        {/* Footer */}
      </div>
    </div>
  )
}

export default MainShow